import { ComingSoon } from "../RevenueShare/ComingSoon/ComingSoon";
import { Hero } from "./Hero/Hero";

/* export const ClaimScreens = [<Hero />]; */
export const ClaimScreens = [<ComingSoon />];
